import styled from "styled-components";

export const ModalPendenciesType = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
    margin-top: 16px;

    .type {
        display: flex;
        align-items: center;
        gap: 20px;
        width: 100%;
        height: 72px;
        border: 1px solid ${({ theme }) => theme.colors.interfacePure100};
        border-radius: 8px;   
        color: ${({ theme }) => theme.colors.interfaceText400};
        font-size: 20px;
        font-weight: 500;
        padding: 24px;
        cursor: pointer;
        transition: all .2s;
        &:hover {
            transform: scale(1.05);
            background-color: ${({ theme }) => theme.colors.interfacePure100};
        }
    }

    .show-type {
        display: flex;
        align-items: center;
        gap: 20px;
        width: 100%;
        height: 72px;
        border: 1px solid ${({ theme }) => theme.colors.background};
        border-radius: 8px;   
        color: ${({ theme }) => theme.colors.interfaceText400};
        font-size: 20px;
        font-weight: 500;
        padding: 24px;
    }

    .description {
        margin-top: 8px;

        span {
           color: ${({ theme }) => theme.colors.interfaceText400};
           font-weight: 400;
        }

        .text {
            width: 100%;
            height: 160px;
            border: 1px solid ${({ theme }) => theme.colors.interfaceText100};
            border-radius: 8px;
            margin-top: 8px;
            padding: 16px;

            &.money {
                height: 80px;
            }

            .text-area {
                width: 100%;
                height: 100%;
                border: none;
                border-radius: 8px;
                resize: none;
                color: ${({ theme }) => theme.colors.interfacePure500};
                font-weight: 500;
                outline: none;
                font-family: Montserrat, sans-serif;
                font-size: 16px;
                line-height: 24px;    
                
                &.highlight {
                    background-color: ${({ theme }) => theme.colors.secondaryPool100};
                }
            }
        }
    }

    .value {
        span {
           color: ${({ theme }) => theme.colors.interfaceText400};
           font-weight: 400;
        }

        .price {
            display: flex;
            align-items: center;
            gap: 24px;
            margin-top: 8px;
        }

        .radio {
            display: flex;
            align-items: center;
            gap: 20px;

            input {
                cursor: pointer;
            }
        }
    }
`

export const ModalWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
    height: fit-content;
    padding: 8px;

    .justify {
        height: 56px;
        &.cancel {
            height: 80px;
        }

        p {
            font-weight: 600;
            color: ${({ theme }) => theme.colors.interfacePure500};
            margin-bottom: 16px;
        }
        span {
            font-weight: 400;
            color: ${({ theme }) => theme.colors.interfacePure500};
        }
    }

    .accept {
        font-weight: 500;
        color: ${({ theme }) => theme.colors.interfaceText400}; 

        p {
            margin-bottom: 24px;
        }

        span {
            font-weight: 400;
        }

        div {
            width: 375px;
            margin-bottom: 24px;
        }
    }

    .refuse {
        height: fit-content;

        p {
            font-weight: 400;
        }
    }
`

export const ModalTitle = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-bottom: 24px;
    border-bottom: 2px solid ${({ theme }) => theme.colors.interfacePure100};

    .points {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 20px;
        font-weight: 700;
        color: ${({ theme }) => theme.colors.interfaceText400};
    }

    .close {
        cursor: pointer;
        transition: all .2s;
        &:hover {
            transform: scale(1.3);
        }
        svg {
            path {
                fill: ${({ theme }) => theme.colors.interfacePure400};
            }
        }
    }
`

export const ModalJustification = styled.div`
    width: 100%;
    height: 120px;
    border: 1px solid ${(props: any) => props.theme.colors.interfaceText100};
    border-radius: 8px;
    padding: 16px;

    .text-area {
        width: 100%;
        height: 100%;
        border: none;
        border-radius: 8px;
        resize: none;
        color: ${({ theme }) => theme.colors.interfaceText500};
        font-weight: 400;
        outline: none;

        &.bold {
            color: ${({ theme }) => theme.colors.interfacePure500};
            font-weight: 500;
        }
    }
`

export const ModalButtons = styled.div`
    display: flex;
    align-items: center;
    gap: 24px;
    justify-content: space-between;
    width: 100%;

    .continue {
        span { color: ${({ theme }) => theme.colors.interfacePure0}; }
    }
`